import { render, staticRenderFns } from "./HistoricSearchResultRow.vue?vue&type=template&id=6ffb5e2e&scoped=true&"
import script from "./HistoricSearchResultRow.vue?vue&type=script&lang=ts&"
export * from "./HistoricSearchResultRow.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricSearchResultRow.vue?vue&type=style&index=0&id=6ffb5e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb5e2e",
  null
  
)

export default component.exports